
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path opacity="0.9" fill-rule="evenodd" clip-rule="evenodd" d="M4.2497 8.91657C3.46735 8.13422 2.19891 8.13422 1.41656 8.91657C0.634217 9.69891 0.634218 10.9673 1.41657 11.7497L6.55161 16.8847C7.33396 17.6671 8.6024 17.6671 9.38474 16.8847C10.1671 16.1024 10.1671 14.834 9.38474 14.0516L4.2497 8.91657Z"></path><path opacity="0.8" fill-rule="evenodd" clip-rule="evenodd" d="M14.5701 11.7498C15.3525 10.9674 15.3525 9.69897 14.5701 8.91663C13.7878 8.13428 12.5193 8.13428 11.737 8.91663L6.60195 14.0517C5.8196 14.834 5.8196 16.1025 6.60195 16.8848C7.3843 17.6672 8.65273 17.6672 9.43508 16.8848L14.5701 11.7498Z"></path><path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M22.5834 11.7498C23.3658 10.9674 23.3658 9.69897 22.5834 8.91663C21.8011 8.13428 20.5327 8.13428 19.7503 8.91663L14.6153 14.0517C13.8329 14.834 13.8329 16.1025 14.6153 16.8848C15.3976 17.6672 16.666 17.6672 17.4484 16.8848L22.5834 11.7498Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiLogoFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
